module.exports = __webpack_public_path__ + "static/page-6-3d1a2156be7512c538b6c8ef9cd86b92.jpg";